import { gql } from '@apollo/client';

export const DELETE_SITE = gql`
  mutation deleteSite($id: ID!) {
    site: deleteSite(id: $id) {
      id
    }
  }
`;
